const store = {
    state: {
        token: '',
        cardId: '',
        planId: '',
        status: 0, // 0 未兑换；1 已兑换
        onlyPlanId: '', // 能兑换的卡册id
    },
    setItem(key, value) {
        this.state[key] = value
    },
    removeItem(key) {
        this.state[key] = ''
    }
}

export default store